import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * HashRedirect Component
 * 
 * A component that redirects to a specified path with optional hash fragment
 * Used with React Router to handle redirections from old URL patterns to new ones
 * 
 * @param {Object} props Component props
 * @param {string} props.to Target path to redirect to (e.g., '/research')
 * @param {string} props.hash Hash fragment without # (e.g., 'problem')
 * @returns {null} Does not render any content
 */
const HashRedirect = ({ to, hash }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const targetUrl = hash ? `${to}#${hash}` : to;
    navigate(targetUrl, { replace: true });
  }, [to, hash, navigate]);

  return null;
};

export default HashRedirect; 